import React, { useState } from "react";
import "../styles/components/Footer.css";
import { Link } from "react-router-dom";

import IconPng from "../components/IconPng";
import Modal from "../components/Modal";
import ContactFormSimple from "../components/ContactFormSimple";

import mailIcon from "../img/contact/mail.png";
import phoneIcon from "../img/contact/phone.png";
import pinIcon from "../img/contact/pin.png";

import ctaBubble from "../img/hero/arrow_2.png";

export default function Footer() {
  const [openModal, setOpenModal] = useState(false);

  return (
    <footer className="ftr" id="footer">
      <div className="ftr__line" />

      <div className="ftr__grid">
        <div className="ftr__tagline">
          <span>"It feels like the app</span>
          <br />
          <span>actually knows me."</span>

          <button
            className="ftr__tagline-pill"
            type="button"
            onClick={() => setOpenModal(true)}
          >
            That's what we build.
          </button>
        </div>

        <nav className="ftr__nav" aria-label="Footer">
          <ul className="ftr__col">
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/cases">Our cases</Link></li>
            <li><Link to="/contacts">Contact us</Link></li>
            <li><Link to="/faq">FAQ</Link></li>
          </ul>
          <ul className="ftr__col">
            <li><Link to="/privacy-policy">Privacy policy</Link></li>
            <li><Link to="/terms">Terms of Service</Link></li>
            <li><Link to="/cookies">Cookie Policy</Link></li>
            <p className="ftr__copy">
  © 2023–{new Date().getFullYear()} Intelligent Writing. All rights reserved.
</p>
          </ul>
        </nav>

        <div className="ftr__contact">
          <div className="ftr__social" aria-label="Social links">
            {/* <a
              href="https://x.com/your"
              className="ftr-social__btn"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="X / Twitter"
            >
              <IconPng name="X" size={40} />
            </a>
            <a
              href="https://t.me/your"
              className="ftr-social__btn"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Telegram"
            >
              <IconPng name="Telegram" size={40} />
            </a> */}
            <a
              href="https://www.linkedin.com/company/intelligent-writing/"
              className="ftr-social__btn"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <IconPng name="LinkedIn" size={40} />
            </a>
          </div>

          <ul className="ftr__info">
            <li>
              <img className="ftr-ico" src={mailIcon} alt="" />
              <a href="mailto:yv@intwriting.com">yv@intwriting.com</a>
            </li>
            <li>
              <img className="ftr-ico" src={phoneIcon} alt="" />
              <a href="tel:+48572304192">+48572304192</a>
            </li>
            <li>
              <img className="ftr-ico" src={pinIcon} alt="" />
              <span>Chmielna 73, 00-801 Warszawa</span>
            </li>
          </ul>
        </div>

        <button className="kb-cta kb-cta--footer" onClick={() => setOpenModal(true)}>
          <span className="kb-cta__label">CONTACT US</span>
          <img src={ctaBubble} alt="" className="kb-cta__bubble" aria-hidden="true" />
        </button>
      </div>

      <Modal open={openModal} onClose={() => setOpenModal(false)} title="Contact us">
        <ContactFormSimple onSubmit={() => setOpenModal(false)} />
      </Modal>
    </footer>
  );
}